export default __webpack_public_path__ + "static/media/feature4.aa02d74b.jpeg";